// components/handleSetNewPassword.js
import { baseBackendURL } from "../helpers/baseUrl";

export const handleSetNewPassword = async (
  e,
  { password, resetToken, setError, setSuccessMessage, setPassword }
) => {
  e.preventDefault();
  setError("");
  setSuccessMessage("");
  try {
    const response = await fetch(
      `${baseBackendURL}/reset_password/${resetToken}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          password,
        }),
        credentials: "include",
      }
    );
    const data = await response.json();
    if (data.success) {
      setSuccessMessage("Password reset successfully.");
      setPassword("");
      window.history.replaceState({}, "", "/");
    } else {
      setError(data.message || "Password reset failed");
    }
  } catch (error) {
    console.error("Error resetting password:", error);
    setError("Unable to reach server. Please try again later.");
  }
};
